import type { RouteFullViewModel } from "api";
import { routeTypesEnum } from "helpers/enums";

export function matchSegmentToSequence(route: RouteFullViewModel) {
    const { segments, segmentSequences } = route;
    if (segments && segmentSequences) {
        route.segments = segments.sort(
            (a, b) =>
                segmentSequences.find((item) => item.segmentId === a.id)!.order -
                segmentSequences.find((item) => item.segmentId === b.id)!.order,
        );
    }

    return route;
}

export const groupedCarRoutes = (
    data?:
        | {
              traveledRouteCoordinates: [number, number][];
              controlPoints: { routeType: keyof typeof routeTypesEnum; index: number }[];
              emulatedSegments: { index: number; startIndex: number; endIndex: number }[];
              startIndex: number;
              endIndex: number;
          }[]
        | undefined,
) =>
    data?.map(
        (item: {
            controlPoints: Array<{ routeType: keyof typeof routeTypesEnum; index: number }>;
            traveledRouteCoordinates: Array<[number, number]>;
            emulatedSegments: { startIndex: number; endIndex: number }[];
            startIndex: number;
            endIndex: number;
        }) => {
            const { controlPoints } = item;
            const traveledRouteCoordinates = item.traveledRouteCoordinates.map((p) => [p[1], p[0]]);

            const mainRouteMeta = controlPoints.find((item) => item.routeType === routeTypesEnum.Main);
            const emulatedSegments = (item?.emulatedSegments || []).reduce(
                (acc, segment) => {
                    if (mainRouteMeta && mainRouteMeta.index > item.startIndex && mainRouteMeta.index < item.endIndex) {
                        acc.push({
                            ...segment,
                            endIndex: mainRouteMeta.index,
                            coordinates: traveledRouteCoordinates.slice(segment.startIndex, mainRouteMeta.index),
                        });
                        acc.push({
                            ...segment,
                            startIndex: mainRouteMeta.index,
                            distance: 0,
                            coordinates: traveledRouteCoordinates.slice(mainRouteMeta.index, segment.endIndex),
                        });
                    } else {
                        acc.push({
                            ...segment,
                            coordinates: traveledRouteCoordinates.slice(segment.startIndex, segment.endIndex),
                            routeType:
                                mainRouteMeta && mainRouteMeta.index > segment.endIndex
                                    ? routeTypesEnum.Main
                                    : routeTypesEnum.EmptyMileage,
                        });
                    }
                    return acc;
                },
                [] as {
                    startIndex: number;
                    endIndex: number;
                    coordinates: number[][];
                    distance?: number;
                    routeType?: string;
                }[],
            );
            return {
                ...item,
                emulatedSegments,
                traveledRouteCoordinates: {
                    [routeTypesEnum.EmptyMileage]: traveledRouteCoordinates.slice(0, mainRouteMeta?.index),
                    [routeTypesEnum.Main]: mainRouteMeta
                        ? traveledRouteCoordinates.slice(mainRouteMeta?.index || 0)
                        : [],
                },
            };
        },
    );
